import React from 'react';
import { ShoppersStyles } from './styles';
import { useAppSelector } from '../../state/hooks';
import {
  ShoppersApps,
  ShoppersCareer,
  ShoppersContact,
  ShoppersFAQ,
  ShoppersFourService,
  ShoppersInstruction,
  ShoppersIntro,
  ShoppersProjects,
  ShoppersSupport,
  ShoppersTeam,
} from '../../components';
import MetaFromApi from '../../components/metaFromApi/MetaFromApi';

export const Shoppers = () => {
  const { interfaceLanguage } = useAppSelector((state) => state.languages);

  return (
    <ShoppersStyles>
      <MetaFromApi slug="shoppers" />
      <ShoppersIntro />
      <ShoppersTeam />
      <ShoppersProjects />
      <ShoppersCareer />
      <ShoppersFourService />
      <ShoppersInstruction />
      <ShoppersFAQ />
      <ShoppersSupport />
      <ShoppersApps />
      <ShoppersContact />
    </ShoppersStyles>
  );
};
